import React from 'react';
import { Search, Plus } from 'lucide-react';
import { Dropdown } from '../../../../../shared/components/atoms/Dropdown';
import { CATEGORIES, inputStyle } from '../../../components/knowledge/KnowledgeUtils';

interface KnowledgeControlsProps {
  search: string;
  setSearch: (val: string) => void;
  catFilter: string;
  setCatFilter: (val: string) => void;
  sortFilter: string;
  setSortFilter: (val: string) => void;
  onUploadClick: () => void;
}

export function KnowledgeControls({ 
  search, 
  setSearch, 
  catFilter, 
  setCatFilter, 
  sortFilter,
  setSortFilter,
  onUploadClick 
}: KnowledgeControlsProps) {
  return (
    <div id="tour-kb-controls" style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap', marginBottom: '24px' }}>
      
      {/* Search Input */}
      <div style={{ position: 'relative', flex: '1 1 300px' }}>
        <Search size={14} style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: 'var(--admin-card-subtext)' }} />
        <input 
          style={{ 
            width: '100%',
            backgroundColor: 'var(--color-bg-elevated, rgba(255,255,255,0.03))',
            border: '1px solid var(--admin-card-border)',
            borderRadius: '0',
            padding: '9px 16px 9px 40px',
            color: 'var(--admin-card-text)',
            fontSize: '13px',
            outline: 'none'
          }} 
          placeholder="Search documents, tags, or authors..." 
          value={search} 
          onChange={e => setSearch(e.target.value)} 
        />
      </div>

      {/* Filters & Actions */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        
        <div style={{ minWidth: '160px' }}>
          <Dropdown
            value={catFilter}
            onChange={setCatFilter}
            options={[
              { value: 'All', label: 'All Categories' },
              ...CATEGORIES.map(c => ({ value: c, label: c }))
            ]}
            className="w-full kb-dropdown-tall"
            placeholder="All Categories"
          />
        </div>

        <div style={{ minWidth: '140px' }}>
          <Dropdown
            value={sortFilter}
            onChange={setSortFilter}
            options={[{ value: 'newest', label: 'Newest first' }, { value: 'oldest', label: 'Oldest first' }]}
            className="w-full kb-dropdown-tall"
          />
        </div>

        <button 
          id="tour-kb-upload"
          onClick={onUploadClick}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px', 
            padding: '9px 16px', 
            borderRadius: '0', 
            fontSize: '13px', 
            fontWeight: 700, 
            border: 'none', 
            cursor: 'pointer', 
            backgroundColor: 'var(--admin-sidebar-logo-text, #ffffff)', 
            color: 'var(--admin-bg-container, #010204)', 
            transition: 'opacity 0.2s' 
          }}
          className="hover:opacity-90"
        >
          <Plus size={16} /> Upload
        </button>

      </div>
      <style>{`
        .kb-dropdown-tall > div:first-child {
          padding-top: 9px !important;
          padding-bottom: 9px !important;
        }
      `}</style>
    </div>
  );
}
